import { Moment } from 'moment';

/* tslint:disable:no-any */
type DueDateCard = any; // TODO: TMON-817 Only pass ids down instead of models
/* tslint:enable:no-any */

export type GroupName =
  | 'overdue'
  | 'due-today'
  | 'due-tomorrow'
  | 'due-week'
  | 'due-later';

const getGroupName = (now: Moment, due: number): GroupName => {
  const withinNextDays = (days: number) =>
    now
      .clone()
      .add(days, 'days')
      .endOf('day')
      .isAfter(due);

  switch (true) {
    case now.clone().isAfter(due):
      return 'overdue';
    case withinNextDays(0):
      return 'due-today';
    case withinNextDays(1):
      return 'due-tomorrow';
    case withinNextDays(7):
      return 'due-week';
    default:
      return 'due-later';
  }
};

const inGroup = (now: Moment, due: number, groupName: GroupName) =>
  groupName === getGroupName(now, due);

interface Group {
  group: GroupName;
  name: string;
  cards: DueDateCard[];
  hide?: boolean;
}

export const getGroups = (
  dueDateCards: DueDateCard[],
  getDueDateOf: (dueDateCard: DueDateCard) => number,
  now: Moment,
  // TODO: TMON-924 Use Gamma's localize function
  l: (key: string) => string,
): Group[] => {
  const groups: Group[] = [
    {
      group: 'overdue',
      name: l('overdue'),
      cards: dueDateCards.filter((dueDateCard) =>
        inGroup(now, getDueDateOf(dueDateCard), 'overdue'),
      ),
      hide: !dueDateCards.some((dueDateCard) =>
        inGroup(now, getDueDateOf(dueDateCard), 'overdue'),
      ),
    },
    {
      group: 'due-today',
      name: l('due-today'),
      cards: dueDateCards.filter((dueDateCard) =>
        inGroup(now, getDueDateOf(dueDateCard), 'due-today'),
      ),
    },
    {
      group: 'due-tomorrow',
      name: l('due-tomorrow'),
      cards: dueDateCards.filter((dueDateCard) =>
        inGroup(now, getDueDateOf(dueDateCard), 'due-tomorrow'),
      ),
    },
    {
      group: 'due-week',
      name: l('due-within-7-days'),
      cards: dueDateCards.filter((dueDateCard) =>
        inGroup(now, getDueDateOf(dueDateCard), 'due-week'),
      ),
    },
    {
      group: 'due-later',
      name: l('due-later'),
      cards: dueDateCards.filter((dueDateCard) =>
        inGroup(now, getDueDateOf(dueDateCard), 'due-later'),
      ),
    },
  ];

  return groups.filter((group) => !group.hide);
};



// WEBPACK FOOTER //
// ./app/scripts/views/home/presentational/team-cards-due-groups.ts